export default __webpack_public_path__ + "static/media/think-different768.28e43720.jpg";